

module.exports = __webpack_require__.stylable.create(
    "Proportion7384634",
    {"classes":{"root":"Proportion7384634__root","ratioHolder":"Proportion7384634__ratioHolder","contentWrapper":"Proportion7384634__contentWrapper"},"vars":{},"stVars":{},"keyframes":{}},
    ".Proportion7384634__root{width:100%;display:-ms-grid;display:grid;position:relative}.Proportion7384634__root>*{-ms-grid-row:1;-ms-grid-row-span:1;-ms-grid-column:1;-ms-grid-column-span:1;grid-area:1/1/2/2}.Proportion7384634__root>.Proportion7384634__ratioHolder{pointer-events:none;max-width:100%}.Proportion7384634__root>.Proportion7384634__contentWrapper{position:absolute;top:0;left:0;width:100%;height:100%}",
    1,
    "Proportion7384634",
    __webpack_require__.stylable.$
);
